import $ from 'jquery';
import 'magnific-popup';
import date from 'date-and-time';

function getFormDataObj($form) {
    const unindexedArray = $form.serializeArray();
    const indexedArray = {};

    $.map(unindexedArray, n => {
        indexedArray[n.name] = n.value;
    });

    return indexedArray;
}

$(document).on('click', 'input[class*="modal-form-async-submit"]', function (e) {
    e.preventDefault();
    const formId = `#${$(this).data('baseId')}-form`;
    const resourceCode = $(this).data('resource');
    const resourceName = $(this).data('resourcename');
    const form = $(formId);
    const formObj = getFormDataObj(form);

    const actionUrl = form.attr('action');

    $.post(actionUrl, formObj, data => {
        if (data.success) {
            // set cookie
            const now = new Date();
            const expiryDate = date.addMonths(now, 1);
            // const dateFormat = 'DD/MM/YYYY$HH:mm:ss';
            const dateFormatLong = 'ddd, DD MMM YYYY HH:mm:ss UTC';
            // const expiryFormat = date.format(expiryDate, dateFormat, true);
            const expiryFormatLong = date.format(expiryDate, dateFormatLong, true);
            document.cookie = `${resourceCode}=true; expires=${expiryFormatLong}; path=/;`;

            // display link
            form.parent().children('.modal-title').first().html(`${resourceName}`);
            form.parent().children('.modal-blurb').first().html('Thank you. Your file is ready for download.');
            form.parent().append(`<div class="modal-download-resource">
            <a href="/resource/${resourceCode}" target="_black" class="btn btn-skin-1">Download</a>
            </div>`);
            form.parent().children('.modal-disclaimer').hide();
            form.hide();
        }
    });
});



// WEBPACK FOOTER //
// ./src/components/modal-form-async/c-modal-form-async.js